/**
 * E ITI POints business service
 */
angular.module("exploitation").factory("EitiPointsBusinessService", [
	"MapService", "ExploitationService",
	function (MapService, ExploitationService) {



	/**
     * API
     */
	return {
		getStopPointsByArea: getStopPointsByArea
	};

	/**
     * Facade service that compute a map extent and call stop points service with that extent.
     *
     * @param map
     * @returns {*}
     */
	function getStopPointsByArea(mapBounds) {
		return ExploitationService.getStopPointsByCoordinates(
			mapBounds._southWest.lat,mapBounds._northEast.lat,
			mapBounds._southWest.lng,mapBounds._northEast.lng
		);
	}


}]);
